export interface CustomGenericInterface {
  name?: string;
  title: string;
  body: string;
}
